import { useEffect, useRef } from "react";
import { createEvent, sample } from "effector";
import { $queue, addToQueue } from "./store/guestsStore";

const processGuestData = createEvent();

// Ensure we only add unique guests
sample({
  clock: processGuestData,
  source: $queue,
  filter: (queue, data) => !queue.some((guest) => guest.id === data.user_id),
  fn: (_, data) => ({
    id: data.user_id,
    name: `${data.user_name} ${data.user_surname}`,
    photo: data.presigned_url,
    likes: data.user_hookah_preferences || [],
    dislikes: data.user_hookah_dislikes || [],
    strength: Array.isArray(data.user_hookah_strength_range)
      ? data.user_hookah_strength_range.join("-")
      : "N/A",

    types: data.user_hookah_types || [],
    rating: data.average_rating || "N/A",
    mobile: data.user_mobile || "Unknown",
  }),
  target: addToQueue,
});

export const useWebSocket = () => {
  const socketRef = useRef(null);

  const connectWebSocket = () => {
    const ws = new WebSocket(
      "wss://hjpgfjbuua.execute-api.eu-west-1.amazonaws.com/production/?place_id=shka17c8h3"
    );
    socketRef.current = ws;

    ws.onopen = () => console.log("✅ WebSocket connected!");

    ws.onmessage = (event) => {
      console.log("📩 WebSocket Message Received:", event.data);
      try {
        const data = JSON.parse(event.data);
        console.log("✅ Parsed WebSocket Data:", data);

        if (data.place_id === "shka17c8h3") {
          processGuestData(data);
        }
      } catch (error) {
        console.error("❌ Error parsing WebSocket message:", error);
      }
    };

    ws.onerror = (error) => console.error("❌ WebSocket error:", error);

    ws.onclose = () => {
      console.warn("⚠️ WebSocket disconnected. Reconnecting in 5 seconds...");
      setTimeout(connectWebSocket, 5000); // ✅ Calls a function, not a Hook
    };
  };

  useEffect(() => {
    connectWebSocket(); // ✅ Establish connection on component mount

    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, []);

  return null;
};
